import React, {useState} from "react";
import "./GomokuBoard.css";
import emptyCell from "./emptyCell.svg";
import whiteCell from "./whiteCell.svg";
import blackCell from "./blackCell.svg";
import whiteCellHover from "./whiteCellHover.svg";
import blackCellHover from "./blackCellHover.svg";

type Board = Array<Array<number | null>>;

enum Piece {
	Black = 1,
	White = 2,
	HoverBlack = 3,
	HoverWhite = 4,
}

interface GomokuBoardProps {
	BOARD_SIZE: number;
	CELL_SIZE: number;
	board: Board;
	player: number;
	winner: number | null;
	setPlayer: (player: number) => void;
	setBoard: (board: Board) => void;
	checkWinner: (row: number, col: number) => void;
}

function GomokuBoard({
	BOARD_SIZE,
	CELL_SIZE,
	board,
	player,
	winner,
	setBoard,
	checkWinner
}: GomokuBoardProps) {
	const [prevRow, setPrevRow] = useState<number | null>(null);
	const [prevCol, setPrevCol] = useState<number | null>(null);

	const handleClick = (row: number, col: number) => {
		if (winner !== null) {
			return;
		}
		if (
			board[row][col] === Piece.HoverBlack ||
			board[row][col] === Piece.HoverWhite ||
			board[row][col] === null
		) {
			const newBoard = board.map((r) => r.slice());
			newBoard[row][col] = player;
			setBoard(newBoard);

			checkWinner(row, col);
			setPrevRow(null);
			setPrevCol(null);
		}
	};

	const handleHover = (row: number, col: number, mouseOn: boolean) => {
		if (winner !== null) {
			return;
		}
		if (mouseOn && row === prevRow && col === prevCol) {
			const newBoard = board.map((r) => r.slice());
			if (player === Piece.Black) {
				newBoard[row][col] = Piece.HoverBlack;
			} else {
				newBoard[row][col] = Piece.HoverWhite;
			}
			// board = newBoard;
			setBoard(newBoard);
		} else if (
			board[row][col] !== Piece.Black &&
			board[row][col] !== Piece.White
		) {
			const newBoard = board.map((r) => r.slice());
			if (player === Piece.Black) {
				newBoard[row][col] = Piece.HoverBlack;
			} else {
				newBoard[row][col] = Piece.HoverWhite;
			}
			if (prevRow !== null && prevCol !== null) {
				newBoard[prevRow][prevCol] = null;
			}
			setBoard(newBoard);
			// board = newBoard;
			setPrevRow(row);
			setPrevCol(col);
		}
	};

	return (
		<div className="GomokuBoard" style={{ minWidth: BOARD_SIZE * CELL_SIZE }}>
			{board.map((row, rowIndex) => (
				<div key={rowIndex} className="row">
					{row.map((cell, colIndex) => (
						<div
							className="Cell"
							key={colIndex}
							onClick={() => handleClick(rowIndex, colIndex)}
							onMouseEnter={() => handleHover(rowIndex, colIndex, true)}
							onMouseLeave={() => handleHover(rowIndex, colIndex, false)}
							style={{
								width: CELL_SIZE,
								height: CELL_SIZE,
								cursor:
									board[rowIndex][colIndex] === Piece.HoverBlack ||
									board[rowIndex][colIndex] === Piece.HoverWhite
										? "pointer"
										: "default",
							}}
						>
							<img
								className="cell"
								src={
									board[rowIndex][colIndex] === Piece.Black
										? blackCell
										: board[rowIndex][colIndex] === Piece.White
										? whiteCell
										: board[rowIndex][colIndex] === Piece.HoverBlack
										? blackCellHover
										: board[rowIndex][colIndex] === Piece.HoverWhite
										? whiteCellHover
										: emptyCell
								}
								alt="cell"
							/>
						</div>
					))}
				</div>
			))}
		</div>
	);
}

export default GomokuBoard;
